import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class I18NStorageService {
  private readonly dictionary$: Subject<any> = new Subject<any>();
  private readonly changeLanguage$: Subject<any> = new Subject<any>();

  constructor() {}
  get dictionary() {
    return this.dictionary$.asObservable();
  }
  setDictionary(value) {
    this.dictionary$.next(value);
  }
  get changeLanguageEvent() {
    return this.changeLanguage$.asObservable();
  }
  setChangeLanguageEvent(value) {
    this.changeLanguage$.next(value);
  }
}
